import type { RefObject } from 'react';
import { createContext, useContext } from 'react';

// Lets recentre helpers (<FitBounds>) flag a move as "programmatic" so
// LeafletMap's moveend listener skips the host's bounds callback. A fit /
// region recentre must NOT trigger a bbox refetch — only genuine user
// pans/zooms and place-search should. Null when no provider is mounted, in
// which case the helpers simply don't flag (back-compatible).
export const ProgrammaticMoveContext = createContext<RefObject<boolean> | null>(
  null
);

export const useProgrammaticMove = () => useContext(ProgrammaticMoveContext);
